var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("会员客户管理")]),
              _c("el-breadcrumb-item", [_vm._v("会员客户信息")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "query" },
        [
          _c("div", { staticClass: "header" }, [
            _c("span", [_vm._v("数据查询")]),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.show3,
                    expression: "!show3",
                  },
                ],
                on: {
                  click: function ($event) {
                    _vm.show3 = true
                  },
                },
              },
              [_vm._v("收起")]
            ),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.show3,
                    expression: "show3",
                  },
                ],
                on: {
                  click: function ($event) {
                    _vm.show3 = false
                  },
                },
              },
              [_vm._v("展开")]
            ),
          ]),
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.show3,
                    expression: "!show3",
                  },
                ],
                staticClass: "polling",
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: { inline: true, model: _vm.queryForm, size: "mini" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "信息" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入客户姓名/手机号码" },
                          model: {
                            value: _vm.queryForm.info,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "info", $$v)
                            },
                            expression: "queryForm.info",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "selectDate" }, [
                      _c("span", [_vm._v("时间")]),
                      _c(
                        "div",
                        { staticClass: "picker" },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "unlink-panels": "",
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              format: "yyyy- MM- dd",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.queryForm.date,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "date", $$v)
                              },
                              expression: "queryForm.date",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "应用名称" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择应用名称",
                              clearable: "",
                              filterable: "",
                              "default-first-option": true,
                            },
                            model: {
                              value: _vm.queryForm.yyname,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "yyname", $$v)
                              },
                              expression: "queryForm.yyname",
                            },
                          },
                          _vm._l(_vm.rank.list, function (items) {
                            return _c("el-option", {
                              key: items.id,
                              attrs: {
                                label: items.applicationName,
                                value: items.applicationName,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "客服" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入客服" },
                          model: {
                            value: _vm.queryForm.service,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "service", $$v)
                            },
                            expression: "queryForm.service",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "会员等级" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入会员等级" },
                          model: {
                            value: _vm.queryForm.grade,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "grade", $$v)
                            },
                            expression: "queryForm.grade",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "地区" } },
                      [
                        _c("levelAddr", {
                          staticClass: "addressContent",
                          attrs: {
                            province: _vm.queryForm.province,
                            city: _vm.queryForm.city,
                            area: _vm.queryForm.area,
                          },
                          on: {
                            updateprovice: _vm.getProvince,
                            updatecity: _vm.getCity,
                            updatearea: _vm.getArea,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.searchEvent()
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        ),
                        _c(
                          "el-button",
                          { attrs: { plain: "" }, on: { click: _vm.reset } },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-bottom": "10px" },
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.addIf = true
                  _vm.param = 3
                },
              },
            },
            [_vm._v("添加客户")]
          ),
          _c(
            "vxe-table",
            {
              staticStyle: { width: "100%" },
              attrs: { align: "center", data: _vm.tableData.list },
            },
            [
              _c("vxe-table-column", {
                attrs: { type: "seq", title: "序号", width: "50" },
              }),
              _c("vxe-table-column", {
                attrs: { title: "姓名", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("p", { staticClass: "nameClick" }, [
                          _vm._v(" " + _vm._s(scope.row.customerName) + " "),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "phone",
                  title: "手机号码",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("p", [_vm._v(_vm._s(scope.row.customerPhone))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "地址",
                  "show-overflow": "",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("p", [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.provinceName) +
                              "," +
                              _vm._s(scope.row.cityName) +
                              "," +
                              _vm._s(scope.row.regionName) +
                              "," +
                              _vm._s(scope.row.detailedAddress) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "应用名称", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("p", [_vm._v(_vm._s(scope.row.applicationName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "客服人员/等级", "min-width": "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("p", [
                          _vm._v(_vm._s(scope.row.customerServiceName)),
                        ]),
                        _c("p", [_vm._v(_vm._s(scope.row.customerType))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "时间", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$moment(scope.row.createdTime))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "操作", "min-width": "150", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.parArray.indexOf("memDetail") != -1
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.detailFix(0, scope.row)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("详情")])]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("memFix") != -1
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.detailFix(1, scope.row)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("修改")])]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("memdelect") != -1
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.delectEvent(scope.row)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("删除")])]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("p", { staticStyle: { height: "10px" } }),
      _vm.tableData.totalNum > 0
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage1,
                    "page-sizes": [10, 20, 50, 100, 200],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.tableData.totalNum,
                    "prev-text": "上一页",
                    "next-text": "下一页",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addIf,
            "append-to-body": true,
            title:
              _vm.param == 3
                ? "添加客户"
                : _vm.param == 1
                ? "修改详情"
                : "查看详情",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addIf = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "contentForm" },
            [
              _c(
                "el-form",
                {
                  ref: "addForm",
                  attrs: {
                    rules: _vm.formRules,
                    model: _vm.addForm,
                    "label-width": "80px",
                    disabled: _vm.param == 0 ? true : false,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "inline" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户姓名", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入客户姓名",
                              maxlength: "32",
                            },
                            model: {
                              value: _vm.addForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "name", $$v)
                              },
                              expression: "addForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户性别", prop: "sex" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "mini",
                                placeholder: "选择性别",
                                "default-first-option": "",
                              },
                              model: {
                                value: _vm.addForm.sex,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addForm, "sex", $$v)
                                },
                                expression: "addForm.sex",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "男", value: "1" },
                              }),
                              _c("el-option", {
                                attrs: { label: "女", value: "2" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "inline" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户年龄", prop: "ago" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入客户年龄",
                              type: "number",
                              maxlength: "32",
                            },
                            model: {
                              value: _vm.addForm.ago,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "ago", $$v)
                              },
                              expression: "addForm.ago",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系电话", prop: "call" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入联系电话",
                              maxlength: "11",
                            },
                            model: {
                              value: _vm.addForm.call,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "call", $$v)
                              },
                              expression: "addForm.call",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "inline" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "消费金额", prop: "salasmoney" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入消费金额",
                              type: "number",
                              maxlength: "32",
                            },
                            model: {
                              value: _vm.addForm.salasmoney,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "salasmoney", $$v)
                              },
                              expression: "addForm.salasmoney",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户积分", prop: "integral" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入客户积分",
                              type: "number",
                              maxlength: "32",
                            },
                            model: {
                              value: _vm.addForm.integral,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "integral", $$v)
                              },
                              expression: "addForm.integral",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "inline" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户经验", prop: "experience" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入客户经验",
                              type: "number",
                              maxlength: "32",
                            },
                            model: {
                              value: _vm.addForm.experience,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "experience", $$v)
                              },
                              expression: "addForm.experience",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客服姓名", prop: "service" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入客服姓名",
                              maxlength: "32",
                            },
                            model: {
                              value: _vm.addForm.service,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "service", $$v)
                              },
                              expression: "addForm.service",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "inline" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "会员等级", prop: "grade" } },
                        [
                          _c("el-input", {
                            attrs: {
                              size: "mini",
                              placeholder: "请输入会员等级",
                              maxlength: "32",
                            },
                            model: {
                              value: _vm.addForm.grade,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "grade", $$v)
                              },
                              expression: "addForm.grade",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户类型", prop: "classtype" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "32",
                              size: "mini",
                              placeholder: "请输入客户类型",
                            },
                            model: {
                              value: _vm.addForm.classtype,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "classtype", $$v)
                              },
                              expression: "addForm.classtype",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "应用名称", prop: "yyname" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "mini",
                            placeholder: "选择应用名称",
                            "default-first-option": "",
                          },
                          on: { change: _vm.changeYY },
                          model: {
                            value: _vm.addForm.yyname,
                            callback: function ($$v) {
                              _vm.$set(_vm.addForm, "yyname", $$v)
                            },
                            expression: "addForm.yyname",
                          },
                        },
                        _vm._l(_vm.rank.list, function (items) {
                          return _c("el-option", {
                            key: items.id,
                            attrs: {
                              label: items.applicationName,
                              value: items.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.propertList
                    ? _c(
                        "div",
                        _vm._l(_vm.propertList, function (items) {
                          return _c(
                            "div",
                            { key: items.propertyName, staticClass: "inline" },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: items.propertyName } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "32",
                                      size: "mini",
                                      placeholder: "请输入信息",
                                    },
                                    model: {
                                      value: items.propertyValue,
                                      callback: function ($$v) {
                                        _vm.$set(items, "propertyValue", $$v)
                                      },
                                      expression: "items.propertyValue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm.param != 3 && _vm.addForm.memberPropertyList
                    ? _c(
                        "div",
                        _vm._l(
                          _vm.addForm.memberPropertyList,
                          function (items) {
                            return _c(
                              "div",
                              {
                                key: items.propertyName,
                                staticClass: "inline",
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: items.propertyLabel } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        maxlength: "32",
                                        size: "mini",
                                        placeholder: "请输入信息",
                                      },
                                      model: {
                                        value: items.propertyValue,
                                        callback: function ($$v) {
                                          _vm.$set(items, "propertyValue", $$v)
                                        },
                                        expression: "items.propertyValue",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "地区", required: "" } },
                    [
                      _c("levelAddr", {
                        staticClass: "addressContent",
                        attrs: {
                          province: _vm.addForm.province,
                          city: _vm.addForm.city,
                          area: _vm.addForm.area,
                          disabled: _vm.param == 0 ? true : false,
                        },
                        on: {
                          updateprovice: _vm.getProvince1,
                          updatecity: _vm.getCity1,
                          updatearea: _vm.getArea1,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "详细地址", prop: "detail" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          placeholder: "请输入详细地址",
                          maxlength: "52",
                        },
                        model: {
                          value: _vm.addForm.detail,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "detail", $$v)
                          },
                          expression: "addForm.detail",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _vm.param == 3
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("addForm")
                                },
                              },
                            },
                            [_vm._v("确定")]
                          )
                        : _vm._e(),
                      _vm.param == 1
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitFormFix("addForm")
                                },
                              },
                            },
                            [_vm._v("确定修改")]
                          )
                        : _vm._e(),
                      _vm.param == 3
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: {
                                click: function ($event) {
                                  _vm.resetForm("addForm")
                                  _vm.addIf = false
                                },
                              },
                            },
                            [_vm._v("取 消")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }